import { memo, useState, Fragment, useCallback } from "react";

import classes from "./DrinkCardSmall.module.css";

import { useCocktails } from "../../../store/CocktailContext";

import DrinkRecipeCard from "../../RecipeCard/DrinkRecipeCard";

import useWindowDimensions from "../../../hooks/useWindowDimensions";



// component which displays basic info about cocktail on drinks list
const DrinkCardSmall = (props) => {
  const { loadedImages } = useCocktails();

  // toggle to open drink recipe card
  const [recipeIsShown, setRecipeIsShown] = useState(false);

  const { width } = useWindowDimensions();

  const showRecipeHandler = useCallback(() => {
    setRecipeIsShown(true);
  }, []);

  const hideRecipeHandler = useCallback(() => {
    setRecipeIsShown(false);
  }, []);
 


  const drinkImage = (
    <img className={classes.drink_image} src={loadedImages[props.drink.image]?.src} alt="new" width="250" height="250"/>
  );

  // when user taps/clicks on component, open drinksRecipeCard which displays all info about cocktail
  // if screem width is greater than 1000px, display drink image in card
  return (
    <Fragment>
      {recipeIsShown && (
        <DrinkRecipeCard drink={props.drink} onClose={hideRecipeHandler} />
      )}
      <div className={classes.drink_card_small} onClick={showRecipeHandler}>
        <div className={classes.drink_name}>{props.drink.title}</div>
        {width > 1000 && (
          <div className={classes.image_blocker} style={{borderImageSource:`url(${process.env.PUBLIC_URL}/assets/borders/border_2.png)`}}>
            {drinkImage}
          </div>
        )}

        <div className={classes.drink_description}>
          {props.drink.description}
        </div>
      </div>
    </Fragment>
  );
};

export default memo(DrinkCardSmall);
